import { defineComponent as _defineComponent } from 'vue'
import { normalizeStyle as _normalizeStyle, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "base-modal__body" }

import {
	computed,
	ref
} from "vue";
import AppLoader from "@/components/common/AppLoader.vue";
import AppIcon from "@/components/ui-kit/icon/AppIcon.vue";

export type QuasarTransitions =
	"slide-right"
	| "slide-left"
	| "slide-up"
	| "slide-down"
	| "fade"
	| "scale"
	| "rotate"
	| "flip-right"
	| "flip-left"
	| "flip-up"
	| "flip-down"
	| "jump-right"
	| "jump-left"
	| "jump-up"
	| "jump-down"

type ModalProps = {
	loading?: boolean,
	persistent?: boolean,
	transitionShow?: QuasarTransitions,
	transitionHide?: QuasarTransitions,
	transitionDuration?: number,
	width?: number | string,
	height?: number | string,
	title?: string,
	position?: { x: number; y: number } | null
}


export default /*@__PURE__*/_defineComponent({
  __name: 'FileCard',
  props: {
    loading: { type: Boolean, default: false },
    persistent: { type: Boolean, default: true },
    transitionShow: { default: "scale" },
    transitionHide: { default: "scale" },
    transitionDuration: { default: 0 },
    width: { default: "55vw" },
    height: { default: "95vh" },
    title: { default: "" },
    position: { default: null }
  },
  emits: ["on-decline", "on-accept", "on-close"],
  setup(__props: any, { expose: __expose, emit: __emit }) {

const props = __props

const emit = __emit

const dialog = ref(false)

const computedStyles = computed(() => {
  const base = {
    maxHeight: '95vh',
    maxWidth: '55vw',
    width: typeof props.width === 'number'
      ? `${props.width}px`
      : props.width,
    height: typeof props.height === 'number'
      ? `${props.height}px`
      : props.height,
  } as Record<string, string>

  if (props.position) {
    base.position = 'fixed'
    base.left = `${props.position.x}px`
    base.top = `${props.position.y}px`
    base.margin = '0'
  }

  return base
})

const loaderStyle = computed(() => ({
	'background-color': 'rgba(255, 255, 255, 0.5)'
}))

const modalEl = ref<HTMLElement | null>(null)

const onOpen = () => {
	dialog.value = true
}

const onClose = () => {
	emit("on-close")
	dialog.value = false
}

const onDecline = () => {
	emit("on-decline")
	dialog.value = false
}

const onAccept = () => {
	emit("on-accept")
	dialog.value = false
}

__expose({
  onOpen,
  onClose,
  onAccept,
  onDecline,
  modalEl
})

return (_ctx: any,_cache: any) => {
  const _component_q_dialog = _resolveComponent("q-dialog")!

  return (dialog.value)
    ? (_openBlock(), _createBlock(_component_q_dialog, {
        key: 0,
        modelValue: dialog.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((dialog).value = $event)),
        persistent: props.persistent,
        "transition-show": props.transitionShow,
        "transition-hide": props.transitionHide,
        "transition-duration": props.transitionDuration,
        onHide: onClose
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", {
            class: "base-modal",
            ref_key: "modalEl",
            ref: modalEl,
            style: _normalizeStyle(computedStyles.value)
          }, [
            _createElementVNode("div", _hoisted_1, [
              (_ctx.loading)
                ? (_openBlock(), _createBlock(AppLoader, {
                    key: 0,
                    style: _normalizeStyle(loaderStyle.value)
                  }, null, 8, ["style"]))
                : _createCommentVNode("", true),
              _renderSlot(_ctx.$slots, "default")
            ])
          ], 4)
        ]),
        _: 3
      }, 8, ["modelValue", "persistent", "transition-show", "transition-hide", "transition-duration"]))
    : _createCommentVNode("", true)
}
}

})